export default "__VITE_ASSET__Caj331u9__"